import Router from 'vue-router'
import Vue from 'vue';



Vue.use(Router);

const routes = [
    // AI校园
    {
        path: '/',
        name: 'Index',
        component: () => import('../views/index.vue')
    },
    //AI宿舍实时出入
    {
        path: '/dorm',
        name: 'dorm',
        component: () => import('../views/dorm/index.vue')
    }
]


const router = new Router({
    mode: 'hash',
    routes
})

export default router
